/**
 * Resolves the total shares/units outstanding for a share class, without ever
 * requiring the full multi-shareholder cap table for non-admin sessions (#5838).
 *
 * Fallback order:
 *   1. clientData.equity[key].totalShares  - static per-class admin override
 *   2. clientData.equity[key].totalOwned   - generic per-class aggregate computed
 *      server-side (see NewServerless/LambdaCode/returnShareholderData), safe for
 *      every user since it's an aggregate number, no per-shareholder rows
 *   3. clientData.metrics.total_units       - legacy client-wide flat number
 *   4. live sum over capTableData           - last resort, admin-only (capTableData
 *      is never populated for non-admin sessions)
 */
export function resolveClassTotalShares(key, { clientData, capTableData, client } = {}) {
	const classConfig = clientData?.equity?.[key] || {};
	if (classConfig.totalShares !== undefined) {
		return Number(classConfig.totalShares);
	}

	if (classConfig.totalOwned !== undefined) {
		return Number(classConfig.totalOwned);
	}

	if (clientData?.metrics?.total_units !== undefined) {
		return Number(clientData.metrics.total_units);
	}

	if (Array.isArray(capTableData)) {
		let total = 0;
		capTableData.forEach((holder) => {
			const holderShares = holder?.clients?.[client]?.shares?.[key];
			if (holderShares?.owned) total += Number(holderShares.owned) || 0;
		});
		return total > 0 ? total : null;
	}

	return null;
}
